/****
 **
 ** Plugins
 **
 ****/

// jQuery
import './vendor/jquery-global.js'

// Common
import Common from './component/common.js'

// Lineup
//import Lineup from "./component/lineup";

// Modal
import Modal from './component/modal.js'

// Scroll Magic
import ScrollMagic from 'scrollmagic'

/****
 **
 ** サイト共通処理
 **
 ****/
;(function () {
  var common = new Common()
})()

/****
 **
 ** Modal
 **
 ****/
;(function () {
  var modal = new Modal()
})()

/****
 **
 ** Modal
 **
 ****/
/*(function() {
  var data = (function() {
    var return_value;
    var req = new XMLHttpRequest();
    req.onreadystatechange = function() {
      if(req.readyState == 4 && req.status == 200){
        return_value = JSON.parse(req.responseText);
      }
    };
    req.open("GET", '/json/lineup.json', false);
    req.send(null);

    return return_value;
  }());

  var lineup = new Lineup({
    card_target: '.js-lineup',
    tag_target: '.p-summary__func:nth-of-type(1) .p-summary__tags',
    year_target: '.p-summary__func:nth-of-type(2)',
    pager_target: '.p-summary',
    tag: true,
    year: true,
    pager: true,
    display_max: 12,
    data: data
  });

  var modal = new Modal();
}());*/

/****
 **
 ** Scroll logo
 **
 ****/
;(function () {
  var controller = new ScrollMagic.Controller()

  // Page top
  var scene3 = new ScrollMagic.Scene({
    triggerElement: '.l-main',
    triggerHook: 0,
  })
    // trigger a velocity opaticy animation
    .setClassToggle('.c-pagetop', 'c-pagetop--visible')
    //.addIndicators() // add indicators (requires plugin)
    .addTo(controller)

  // Page top
  var scene3 = new ScrollMagic.Scene({
    triggerElement: '.l-main',
    triggerHook: 0,
  })
    // trigger a velocity opaticy animation
    .setClassToggle('html', 'is-notfirstview')
    //.addIndicators() // add indicators (requires plugin)
    .addTo(controller)

  // Page top
  var scene3 = new ScrollMagic.Scene({
    triggerElement: '.l-header__head',
    triggerHook: 0,
  })
    // trigger a velocity opaticy animation
    .setClassToggle('html', 'is-scrolled')
    //.addIndicators() // add indicators (requires plugin)
    .addTo(controller)
})()

/****
 **
 ** pager(WP-navi)カスタム
 **
 ****/
;(function () {
  var $pager = $('.js-pager')

  if ($pager.length) {
    var $pagenavi = $pager.find('.wp-pagenavi')
    if ($pagenavi.find('.current:first-child').length) {
      $pagenavi.prepend(
        '<a class="arrow previouspostslink disabled" rel="prev" aria-label="Prev Page" href="#">Prev</a>',
      )
    }
    if ($pagenavi.find('.current:last-child').length) {
      $pagenavi.append('<a class="arrow nextpostslink disabled" rel="next" aria-label="Next Page" href="#">Next</a>')
    }
  }
})()
